import { render, staticRenderFns } from "./CityVehicleModelListEdit.vue?vue&type=template&id=2d13222f&"
import script from "./CityVehicleModelListEdit.vue?vue&type=script&lang=js&"
export * from "./CityVehicleModelListEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports